// ControlTableFactory.js

import $ from 'jquery';

import BaseVisualControlFactory	from 'BaseVisualControlFactory.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import GridColumnModel    from 'GridColumnModel.js';

import ControlModel    from 'ControlModel.js';
import TableControlView from 'advanced-inputs/TableControlView.js';

//=============================================================================
//
// Creates a complex table control, given a factoryService
// parameter key and a layout postion. The factory parameter defines the 
// rectangle of the control via a width and height from the factory parameter.
//
// -Lou Mauget, December 7, 2015 -- Pearl Harbor Day
//
//=============================================================================
class ControlTableFactory extends BaseVisualControlFactory {
	constructor () {
		super();
	}

	createView( factoryKey, pos ) {

  		const attributes = this.createChildAttributes(  factoryKey, pos ) ;
		attributes.showHeader = 'true';
		attributes.headerHeight = '25';
		attributes.buttons = 'bottom';
		attributes.allowColumnResize = true;
		attributes.showFooter = 'false';
		attributes.styleHeaderColorText = '~tableHeaderTextColor';
		attributes.headerBoldSelection = 'transparent';
		attributes.headerItalicSelection = 'transparent';
		attributes.headerBgColor = '~tableHeaderBgColor';
		attributes.headerBgColorGradient = '~tableHeaderBgGradientColor';
		attributes.normalRowBgColor = '~tableRowColor1';
		attributes.alternateRowBgColor = '~tableRowColor2';
		attributes.backgroundColor = '~tableBgColor';
		attributes.styleBGColorText = '';
		attributes.headerTextColor ='~tableHeaderTextColor'
		attributes.headerFontFamily = '~tableHeaderFont';
		attributes.headerFontSize = '~tableHeaderFont';
		attributes.headerTextWeight = '~tableHeaderFont';
		attributes.headerTextStyle = '~tableHeaderFont';
		attributes.borderSize = '~tableBorder';
		attributes.borderStyle = '~tableBorder';
		attributes.cornerRadius = '~tableBorder';
		attributes.borderColor = '~tableBorderColor';
		attributes.rowHeight = '25';
		attributes.maxRows = '150000';
		attributes.columnsWidths = '';
		attributes.horizontalScroll = true;
		//attributes.columns = ['Column 1', 'Column 2'];
		//attributes.colModel = [{name: 'Column 1',index: 'Column 1', width: 150},
		//	{name: 'Column 2',index: 'Column 2',width: 150}];
		attributes.selectFields = [{text: 'Text Input Column 1 - Current Row'}, {text: 'Text Input Column 1 - All Rows'},
			{text: 'Text Input Column 2 - Current Row'}, {text: 'Text Input Column 2 - All Rows'}];
		
		// Grid Data Shared Initialing for all views
		attributes.gridData = [];
		attributes.gridData.push(this.getDefaultColumn(0, 'Column 1', 'Text input Column 1'));
		attributes.gridData.push(this.getDefaultColumn(1, 'Column 2', 'Text input Column 2'));
		attributes.minWidth = 120;
		attributes.minHeight = 150;
		attributes.translateProps = [
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"}
        ];

		return new TableControlView({
			model: new ControlModel(attributes),
			el: $(constants.FORM_ID),
			pos: pos,
			factoryKey: factoryKey,
			id: attributes.id
		}); 
	}

	getDefaultColumn(index, header, name) {
		return new GridColumnModel({
			id: sequenceService.nextDomId(),
			index: index,
			header: header,
			format: 'normal',
			type: 'tbl_textInput',
			name: name,
			factoryKey: 'textInputColumn',
			width: 171,
		  	state:new Map(),
		  	stateDisplay:"default"
		})
	}

}

const controlTableFactory = new ControlTableFactory();

export default controlTableFactory;
